import CustomerForm from '../components/CustomerForm';
import { useNavigate, useParams } from 'react-router-dom';
import { Stack } from '@mui/material';
import { useMutateCustomerHandler } from '../dataHandlers/mutateCustomerHandler';
import { useGetCustomerHandler } from '../dataHandlers/getCustomerHandler';
import { DEFAULT_CUSTOMER_TYPE } from '../../../constants/defaults';
import { useState, useEffect } from 'react';
import { usePermissions } from '../../../hooks/usePermissions';
import { UPDATE_CUSTOMER } from '../../../constants/eInvoicePermissions';
import { useActionDeniedSnackbar } from '../../../hooks/useActionDeniedSnackbar';

export default function EditCustomerPage() {
  const navigate = useNavigate();
  const { loading, hasEInvoicePermission } = usePermissions();
  const showActionDeniedSnackbar = useActionDeniedSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onCustomerCreated = (payload) => {
    navigate('/customers');
  };
  const { profile_id } = useParams();
  const { customer, isLoading: isLoadingData } = useGetCustomerHandler(profile_id);
  const { onSubmit, error, isPending } = useMutateCustomerHandler({ onSuccess: onCustomerCreated });

  useEffect(() => {
    if (loading) {
      return;
    }
    if (!hasEInvoicePermission(UPDATE_CUSTOMER)) {
      showActionDeniedSnackbar();
      navigate('/customers', { replace: true });
    }
  }, [loading, hasEInvoicePermission, showActionDeniedSnackbar, navigate]);

  // Reset isSubmitting when mutation completes
  useEffect(() => {
    if (!isPending && isSubmitting) {
      setIsSubmitting(false);
    }
  }, [isPending, isSubmitting]);

  const handleSubmit = async (payload) => {
    setIsSubmitting(true);
    onSubmit(payload, true);
  };

  function handleCancel() {
    return navigate('/customers');
  }

  if (isLoadingData || !customer) {
    return null;
  }

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <CustomerForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        initialData={customer}
        edit={true}
        apiErrors={error}
        customerType={customer.type ?? DEFAULT_CUSTOMER_TYPE}
        isLoading={isPending || isLoadingData || isSubmitting}
      ></CustomerForm>
    </Stack>
  );
}
